module.exports = __webpack_public_path__ + "static/media/Basil.871c221e.png";